// extracted by mini-css-extract-plugin
export default {"resumeExperienceSection":"ResumeExperience_resumeExperienceSection__0UECg","experience":"ResumeExperience_experience__vbYXn"};